import { Collapse } from "components/ui/collapse/Collapse"
import { ModelNumbersColumns } from "./TableModelNumbersColumns"
import { MODEL_NUMBER_COLUMN_WIDTHS } from "./TableModelNumbers.constants"
import { useCollapseModelNumbers } from "components/pages/PageConfiguration/layout/ModelNumbers/layout/TableModelNumbers/TableModelNumbersCollapse.hook"
import { useTableModelNumbersHandles } from "components/pages/PageConfiguration/layout/ModelNumbers/layout/TableModelNumbers/TableModelNumbersHandles"
import { useGetModelNumbers } from "hooks/api/modelNumbers/modelNumbers.hook"
import { Skeleton } from "components/ui/skeleton/Skeleton"
import type { TModelNumbersData } from "types/modelNumbers.type"
import style from "./TableModelNumbers.module.scss"

const { tableModelNumbers, noData, tableHeader, headerColumn } = style

const HEADER_COLUMNS = [
	{ title: "", width: MODEL_NUMBER_COLUMN_WIDTHS.modelNumber },
	{ title: "WIDTH", width: MODEL_NUMBER_COLUMN_WIDTHS.width },
	{ title: "HEIGHT", width: MODEL_NUMBER_COLUMN_WIDTHS.height },
	{ title: "DEPTH", width: MODEL_NUMBER_COLUMN_WIDTHS.depth },
	{ title: "MIN SIZE", width: MODEL_NUMBER_COLUMN_WIDTHS.minSize },
	{ title: "AVG SIZE", width: MODEL_NUMBER_COLUMN_WIDTHS.avgSize },
	{ title: "MAX SIZE", width: MODEL_NUMBER_COLUMN_WIDTHS.maxSize },
]

export const TableModelNumbers = () => {
	const { data: modelNumbers, isPending: isModelNumbersPending } = useGetModelNumbers()
	const columns = ModelNumbersColumns()
	const { onRowHandle } = useTableModelNumbersHandles()
	const { generateCollapseItems } = useCollapseModelNumbers({ columns, onRowHandle })
	const collapseItems = generateCollapseItems(modelNumbers as TModelNumbersData)

	if (isModelNumbersPending) {
		return (
			<div className={tableModelNumbers}>
				<div data-testid="skeleton">
					<Skeleton rows={10} />
				</div>
			</div>
		)
	}

	return (
		<div className={tableModelNumbers}>
			{collapseItems.length > 0 ? (
				<>
					<div className={tableHeader} data-testid="table-header">
						<span />
						{HEADER_COLUMNS.map((col) => (
							<span key={col.title} className={headerColumn} style={{ width: col.width }}>
								{col.title}
							</span>
						))}
					</div>
					<Collapse items={collapseItems} />
				</>
			) : (
				<div className={noData}>No data available</div>
			)}
		</div>
	)
}
